import { Injectable } from '@angular/core';
import { BooleanSettingGuard } from '../../common/guard/boolean-setting.guard';

@Injectable()
export class VehiclesConfigHubGuard extends BooleanSettingGuard {
    protected get settingsValues(): boolean[] {
        return [
            this.userSettings.shouldShowVehicleManagement(),
            this.userSettings.isPassengerResetStopsEnabled()
        ];
    }
}
